function resolverCampo(item, campo) {
  const ruta = String(campo || '').trim()
  if (!ruta) throw new Error('El parámetro campo de totalizarArray es obligatorio')

  return ruta.split('.').reduce((actual, segmento) => {
    if (actual == null) return undefined
    return actual[segmento]
  }, item)
}

function tieneDatos(valor) {
  if (valor == null) return false
  if (Array.isArray(valor)) return valor.length > 0
  return String(valor) !== ''
}

function cumpleFiltro(valor, filtro) {
  if (filtro == null || filtro === '') return true

  if (Array.isArray(valor)) {
    return valor.some((item) => item != null && String(item).includes(String(filtro)))
  }

  return String(valor).includes(String(filtro))
}

export function totalizarArray(valores, campo, filtro, textoSinValores = '') {
  if (!Array.isArray(valores)) {
    throw new Error('El primer parámetro de totalizarArray debe resolver a un array')
  }

  const total = valores.filter((item) => {
    const valorCampo = resolverCampo(item, campo)
    return tieneDatos(valorCampo) && cumpleFiltro(valorCampo, filtro)
  }).length

  if (total === 0) return textoSinValores == null ? '' : String(textoSinValores)
  return String(total)
}
